module.exports = __webpack_public_path__ + "img/tema-3-12.7d65f3c7.png";